import React, { useState } from "react";
import WarehouseTopBar from "../components/warehouse/WarehouseTopBar";

import StockTab from "../components/warehouse/tabs/StockTab";
import ReceiptsTab from "../components/warehouse/tabs/ReceiptsTab";
import IssuesTab from "../components/warehouse/tabs/IssuesTab";
import InventoryTab from "../components/warehouse/tabs/InventoryTab";
import MovementsTab from "../components/warehouse/tabs/MovementsTab";
import SuppliersTab from "../components/warehouse/tabs/SuppliersTab";
import SalesTab from "../components/warehouse/tabs/SalesTab";

export default function WarehousePage() {
  const [tab, setTab] = useState("stock");

  return (
    <div className="warehouse-page">
      <WarehouseTopBar tab={tab} onChange={setTab} />

      {tab === "stock" && <StockTab />}
      {tab === "receipts" && <ReceiptsTab />}
      {tab === "issues" && <IssuesTab />}
      {tab === "inventory" && <InventoryTab />}
      {tab === "sales" && <SalesTab />}
      {tab === "movements" && <MovementsTab />}
      {tab === "suppliers" && <SuppliersTab />}
    </div>
  );
}
